'use strict'

/**
 * XYZColor
 * Workflow: lightweight value container for XYZ components.
 */
class XYZColor {
    /**
     * @param {number} x X component.
     * @param {number} y Y component.
     * @param {number} z Z component.
     */
    constructor(x = 0.0, y = 0.0, z = 0.0) {
        this.x = x
        this.y = y
        this.z = z
    }
}

export default XYZColor
